
import InputWrapper from '@/components/common/InputWrapper.vue'
import Select from '@/components/common/Select.vue'
import TransactionList from '@/components/TransactionList.vue'
import Modal from '@/components/common/Modal.vue'
import Nav from '@/components/Nav.vue'
import InputText from '@/components/common/InputText.vue'
import InputNumeric from '@/components/common/InputNumeric.vue'
import Tables from '@/components/common/TablesDb.vue'
import ContractBox from '@/components/ContractBox.vue'

import { useApi } from '@/lib/api'
import { errorMap } from '@/lib/filters'
import { defineComponent, ref, getCurrentInstance, markRaw } from 'vue'
import { useRouter } from 'vue-router'

const actions = markRaw({
  template: `<a href class="text-bold" @click.prevent="$parent.$parent.setContractId(data)">Izberi </a>`,
  props: {
    data: {}
  }
})

export default defineComponent({
  components: { Select, TransactionList, InputWrapper, Nav, Modal, InputText, InputNumeric, Tables, ContractBox },
  setup() {
    const _api = useApi()
    const _inst = getCurrentInstance()
    const _router = useRouter()
    const data = ref<any>({ contract: {}, transactionList: [{ idPrev: null, taxNumber: '', amount: '', currency: {} }] })
    const contract = ref({})
    const contractList = ref([])
    const transactionList = ref([])
    const clientList = ref([])
    const filter = ref({ pagerPage: 1, pagerPageSize: 20, pagerSort: 'np.id desc' })
    const idEur = ref()
    const dlg = ref()
    const cols = ref([
      { field: 'id', caption: '#', dbField: 'np.id', hidden: true },
      { field: 'jnTitle', caption: 'Št. JN', dbField: 'jn' },
      { field: 'title', caption: 'Pogodba', dbField: 'np.naziv' },
      { field: 'client.title', caption: 'Naročnik', dbField: 'narocnik' },
      { field: 'value', caption: 'Znesek pogodbe', dbField: 'vrednost', class: 'text-right-important', format: { type: 'number', format: 2 } },
      { field: 'dateFrom', caption: 'Poročanje od', format: { type: 'date', format: 'DD.MM.YYYY' }, dbField: 'datum_od' },
      { field: 'dateTo', caption: 'Poročanje do', format: { type: 'date', format: 'DD.MM.YYYY' }, dbField: 'datum_do' },
      //{ field: 'active', caption: 'Aktivnost', format: { type: 'yesno' }, dbField: 'NP.aktiven' },
      { caption: 'Akcija', component: actions, class: 'nowrap actions' }
    ])

    const getSifData = async () => {
      let res = await _api.get<any>('clientList')
      clientList.value = res.data.map((x: any) => ({
        id: x.id,
        text: x.title
      }))
      const n = { id: null, text: '- izberi -' }
      clientList.value.unshift(n as never)

      res = await _api.cache.get<any>('sifList?type=currency')
      idEur.value = res.data.filter((x: any) => x.text === 'EUR')[0].id
      data.value.transactionList[0].currency.id = idEur.value
    }

    const getContractList = async (e?: any) => {
      if (e) {
        filter.value.pagerPage = e.page
        filter.value.pagerSort = e.sort ? e.sort : 'np.id desc'
      } else if (filter.value.pagerPage > 1) {
        filter.value.pagerPage = 1
        return
      }
      const res = await _api.post<any>('contractList', filter.value, true)
      contractList.value = res.data
    }

    const submit = async (validate: boolean) => {
      const res = await _api.post<any>('reportWrite?validate=' + validate, data.value)
      if (res.status === 200) {
        if (validate) {
          dlg.value.open()
        } else {
          dlg.value.close()
          _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Poročilo oddano.' })
          _router.push({ name: 'reportList', params: { id: res.data } })
        }
      }
    }

    const getTransactionList = async (id: any) => {
      const res = await _api.get<any>('transactionList?idContract=' + id, data.value)
      if (res.status === 200) {
        transactionList.value = res.data
      }
    }

    const cancelTransaction = (p: any) => {
      const trans = JSON.parse(JSON.stringify(p))
      trans.id = null
      trans.idPrev = p.id
      let t = data.value.transactionList[data.value.transactionList.length - 1]
      if (t && t.amount === '') {
        t.taxNumber = trans.taxNumber
        t.description = trans.description
        t.datePayment = trans.datePayment
        t.amount = trans.amount
        t.currency = trans.currency
        t.idPrev = trans.idPrev
      } else {
        data.value.transactionList.push(trans)
      }
    }

    const setContractId = (con: any) => {
      contract.value = { contract: con }
      data.value.contract.id = con.id
      getTransactionList(con.id)
    }

    getSifData()

    return { contract, setContractId, cols, getContractList, data, contractList, transactionList, clientList, submit, errorMap, getTransactionList, cancelTransaction, idEur, dlg, filter }
  }
})
